import "./ForgotPassword.css";
// import logo from "../assets/logo.png";

const ForgotPassword = () => {
  return (
    <div className="fp-page">
      <div className="fp-container">
        {/* HEADER */}
    
        {/* CONTENT */}
        <div className="fp-content">
          {/* LEFT FORM */}
          <div className="fp-form">
            <div className="fp-field">
              <label>Email address *</label>
              <input type="email" placeholder="Enter your email" />
            </div>

            <button className="fp-btn primary">Submit</button>
            <button className="fp-btn secondary">Back</button>
          </div>

          {/* RIGHT LINKS */}
          <div className="fp-links">
            <h4>Other Links</h4>
            <a href="/register">Create a new account</a>
            <a href="/contact">Contact Us</a>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="fp-footer">
          <div>
            © 2026 Nx Optics LIMITED. All Rights Reserved.{" "}
            <a href="#">Terms of Use</a> | <a href="#">Privacy Policy</a>
          </div>
          <div>TrustedSite • digicert • ⭐ 4.9</div>
        </footer>
      </div>
    </div>
  );
};

export default ForgotPassword;
